/**
 * This is a JavaScript file since `next.config.js` cannot transpile TypeScript.
 */
const APPLICATION_BASE_PATH = "/jsonata/playground";

module.exports = { APPLICATION_BASE_PATH };
